// extracted by mini-css-extract-plugin
export default {"section":"CurrentInternationalRail_section__0Psue","header":"CurrentInternationalRail_header__FLWAc","rail":"CurrentInternationalRail_rail__UxSla"};